import { render, staticRenderFns } from "./Panes.vue?vue&type=template&id=d50b8c6c&"
import script from "./Panes.vue?vue&type=script&lang=js&"
export * from "./Panes.vue?vue&type=script&lang=js&"
import style0 from "./Panes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports